module.exports = __webpack_public_path__ + "static/media/heart-balloon.2779537e.svg";